import { Model, Watchable } from '@cotera/client/v0/actions/framework';

const DEV_MODE_STORAGE_KEY = 'COTERA_DEV_MODE';

export class DevModeModel implements Model {
  readonly id = 'dev-mode';

  readonly enabled: Watchable<boolean> = Watchable.fromValue(
    localStorage.getItem(DEV_MODE_STORAGE_KEY) === 'true'
  );

  constructor() {
    //get from local storage
    const enabled = localStorage.getItem(DEV_MODE_STORAGE_KEY);
    if (enabled) {
      this.enabled.set(enabled === 'true');
    }
  }

  enable() {
    localStorage.setItem(DEV_MODE_STORAGE_KEY, 'true');
    this.enabled.set(true);
  }

  disable() {
    localStorage.setItem(DEV_MODE_STORAGE_KEY, 'false');
    this.enabled.set(false);
  }
}
